import { adminFunctions } from '../adminFunctions';
import { featureCategories } from '../../data/filterOptions';

const defaultFeatures = {
  // Construction Features
  toolMarks: {
    label: 'Tool Marks',
    description: 'Evidence of ancient construction tools',
    category: 'construction',
    source: 'system',
    active: true
  },
  wedgeHoles: {
    label: 'Wedge Holes',
    description: 'Holes created for stone splitting',
    category: 'construction',
    source: 'system',
    active: true
  },
  plugHoles: {
    label: 'Plug Holes',
    description: 'Holes used for stone lifting',
    category: 'construction',
    source: 'system',
    active: true
  },

  // Architectural Features
  megalithicWall: {
    label: 'Megalithic Wall',
    description: 'Walls built with massive stone blocks',
    category: 'architectural',
    source: 'system',
    active: true
  },
  polygonalWall: {
    label: 'Polygonal Wall',
    description: 'Walls with interlocking polygonal stones',
    category: 'architectural',
    source: 'system',
    active: true
  },
  ashlarWall: {
    label: 'Ashlar Wall',
    description: 'Walls with precisely cut rectangular stones',
    category: 'architectural',
    source: 'system',
    active: true
  },

  // Cultural Features
  petroglyphs: {
    label: 'Petroglyphs',
    description: 'Rock carvings or inscriptions',
    category: 'cultural',
    source: 'system',
    active: true
  },
  altars: {
    label: 'Altars',
    description: 'Ancient ceremonial structures',
    category: 'cultural',
    source: 'system',
    active: true
  },
  stelae: {
    label: 'Stelae',
    description: 'Upright stone slabs with carvings',
    category: 'cultural',
    source: 'system',
    active: true
  },

  // Natural Features
  bedrock: {
    label: 'Bedrock Integration',
    description: 'Construction integrated with natural rock',
    category: 'natural',
    source: 'system',
    active: true
  },
  geologicalFeatures: {
    label: 'Geological Features',
    description: 'Natural rock formations',
    category: 'natural',
    source: 'system',
    active: true
  },

  // Artistic Features
  reliefs: {
    label: 'Stone Reliefs',
    description: 'Carved decorative elements',
    category: 'artistic',
    source: 'system',
    active: true
  },
  sculptures: {
    label: 'Stone Sculptures',
    description: 'Free-standing carved figures',
    category: 'artistic',
    source: 'system',
    active: true
  }
};

export async function initializeFeatures() {
  console.log('Starting feature initialization...');
  
  try {
    let featuresCreated = 0;
    let featuresSkipped = 0;

    // Initialize each predefined feature
    for (const [featureId, feature] of Object.entries(defaultFeatures)) {
      try {
        await adminFunctions.createFeature({
          id: featureId,
          ...feature
        });
        featuresCreated++;
      } catch (error) {
        // Skip if feature already exists
        if (error.message.includes('already exists')) {
          featuresSkipped++;
        } else {
          throw error;
        }
      }
    }

    // Add features to their categories
    for (const [featureId, feature] of Object.entries(defaultFeatures)) {
      const category = feature.category;
      if (featureCategories[category]) {
        featureCategories[category].features = featureCategories[category].features || [];
        if (!featureCategories[category].features.includes(featureId)) {
          featureCategories[category].features.push(featureId);
        }
      }
    }

    console.log(`Feature initialization complete. Created: ${featuresCreated}, Skipped: ${featuresSkipped}`);
    return { success: true, data: { created: featuresCreated, skipped: featuresSkipped } };

  } catch (error) {
    console.error('Error during feature initialization:', error);
    return { success: false, error: error.message };
  }
}
